// Custom javascript
import curtain from "./components/curtain";
import videoControl from "./components/videoControl";
import navbarBurger from "./components/navbarBurger";
import navbarNavigation from "./components/navbarNavigation";
import svgInject from "./components/svgInject";
import lazyLoad from "./components/lazyLoad";
import accordion from "./components/accordion";
import passwordReveal from "./components/passwordReveal";
import tooltipTippy from "./components/tooltip-tippy";
import tabs from "./components/tabs";
import videoSwiper from "./components/videoSwiper";
import selectSwiper from "./components/selectSwiper";
import checkbox from "./components/checkbox";
import accordionContainer from "./components/accordionContainer";
import compareHeader from "./components/compareHeader";
import newsletter from "./components/newsletter";

// GSAP
import gsapAnimateOnScroll from "./components/gsap/gsapAnimateOnScroll";
import gsapProductFixed from "./components/gsap/gsapProductFixed";
import gsapProductFeatures from "./components/gsap/gsapProductFeatures";
import gsapProductFixedNoFeatures from "./components/gsap/gsapProductFixedNoFeatures";
import gsapNavbar from "./components/gsap/gsapNavbar";
import gsapNavigationAnchors from "./components/gsap/gsapNavigationAnchors";
import gsapEcommerceProductFixed from "./components/gsap/gsapEcommerceProductFixed";
import gsapEcommerceSummaryBoxFixed from "./components/gsap/gsapEcommerceSummaryBoxFixed";

// Swiper
import swiperMainSlider from "./components/swiperMainSlider";
import swiperProductIntro from "./components/swiperProductIntro";

// React
import reactBootstrap from "./react/boostrapper";


const appInit = () => {

    const appBootstrap = () => {
        // critical css curtain -> avoid flashing on page load (empty css, wrong font, big svg, etc...)
        curtain.init();

        // Libraries init
        svgInject.init();
        lazyLoad.init();
        tooltipTippy.init();

        // Components
        videoControl.init();
        navbarBurger.init();
        navbarNavigation.init();
        accordion.init();
        passwordReveal.init();
        tabs.init();
        checkbox.init();
        accordionContainer.init();
        compareHeader.init();
        newsletter.init();

        // GSAP
        gsapAnimateOnScroll.init();
        gsapProductFixed.init();
        gsapProductFixedNoFeatures.init();
        gsapProductFeatures.init();
        gsapNavbar.init();
        gsapNavigationAnchors.init();
        gsapEcommerceProductFixed.init();
        gsapEcommerceSummaryBoxFixed.init();

        // Swiper init
        swiperMainSlider.init();
        swiperProductIntro.init();
        videoSwiper.init();
        selectSwiper.init();

        // React
        reactBootstrap();

    }

    appBootstrap();
}

appInit();
